import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import './LeadsUpdatedVersion.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import RatingComponent from "./Rating";
import Swal from "sweetalert2";
import RatingEditComponent from "./RatingEdit";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";
import { Bell, ChevronDown, EditIcon, Mail, StickyNote } from "lucide-react";
import axios from "axios";
import {
    ensureCrmNotificationPermission,
    scheduleCrmReminderAfterSave,
} from "../../utils/crmReminderNotifications";
const convertToINRWords = (amount) => {
    const words = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
        "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

    const numToWords = (num) => {
        if (num < 20) return words[num];
        if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + words[num % 10] : "");
        if (num < 1000) return words[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " and " + numToWords(num % 100) : "");
        if (num < 100000) return numToWords(Math.floor(num / 1000)) + " Thousand" + (num % 1000 !== 0 ? " " + numToWords(num % 1000) : "");
        if (num < 10000000) return numToWords(Math.floor(num / 100000)) + " Lakh" + (num % 100000 !== 0 ? " " + numToWords(num % 100000) : "");
        return numToWords(Math.floor(num / 10000000)) + " Crore" + (num % 10000000 !== 0 ? " " + numToWords(num % 10000000) : "");
    };

    if (isNaN(amount)) return "";

    const wholePart = Math.floor(amount);
    const result = numToWords(wholePart);

    return `Rupees ${result} Only`;
};

const formatIndianCurrency = (value) => {
    const num = value.replace(/,/g, ''); // Remove commas
    if (!/^\d+$/.test(num)) return value; // Only format if valid number
    return Number(num).toLocaleString('en-IN');
};

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const inWords = (n) => {
        if ((n = n.toString()).length > 9) return 'Overflow';
        const nNum = ('000000000' + n).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!nNum) return;
        let str = '';
        str += nNum[1] !== '00' ? (a[Number(nNum[1])] || b[nNum[1][0]] + ' ' + a[nNum[1][1]]) + ' Crore ' : '';
        str += nNum[2] !== '00' ? (a[Number(nNum[2])] || b[nNum[2][0]] + ' ' + a[nNum[2][1]]) + ' Lakh ' : '';
        str += nNum[3] !== '00' ? (a[Number(nNum[3])] || b[nNum[3][0]] + ' ' + a[nNum[3][1]]) + ' Thousand ' : '';
        str += nNum[4] !== '0' ? a[Number(nNum[4])] + ' Hundred ' : '';
        str += nNum[5] !== '00' ? ((str !== '') ? 'and ' : '') + (a[Number(nNum[5])] || b[nNum[5][0]] + ' ' + a[nNum[5][1]]) + ' ' : '';
        return str.trim() + ' Rupees Only';
    };

    return inWords(num.replace(/,/g, ''));
};


const CRMUpdatedVersionCards = (
    { leads, setLeads, selectedLeads, setSelectedLeads, currentPage, newlyAssignedLeads, setNewlyAssignedLeads, alreadyAssignedLeads, setAlreadyAssignedLeads, leadsDataMain }) => {
    const [starredLeads, setStarredLeads] = useState({});
    const [showQuotationModal, setShowQuotationModal] = useState(false);
    const [openCardId, setOpenCardId] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [showReminderModal, setShowReminderModal] = useState(false);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const [pricePerUnit, setPricePerUnit] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [showGST, setShowGST] = useState(false);
    const [gst, setGst] = useState("");
    const [showDiscount, setShowDiscount] = useState(false);
    const [discount, setDiscount] = useState("");
    const [productName, setProductName] = useState("");
    const [addNote, setAddNote] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const [notes, setNotes] = useState("");
    const [clickedContact, setClickedContact] = useState(false);
    const [showEnquiryModalEdit, setShowEnquiryModalEdit] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [notesData, setNotesData] = useState([]);
    const [leadsData, setLeadsData] = useState({})
    const [leadStatus, setLeadStatus] = useState("");
    const navigate = useNavigate();
    const [showRatingPopup, setShowRatingPopup] = useState(false);
    const [selectedLeadForRating, setSelectedLeadForRating] = useState(null);
    const [services, setServices] = useState([]);
    const [customTime, setCustomTime] = useState(null);
    const [customDate, setCustomDate] = useState(null);
    const [employeeViewFilter, setEmployeeViewFilter] = useState(null);
    const [namemain, setNameMain] = useState("")
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        mobile: "",
        business_name: "",
        address: "",
        city: "",
        pincode: "",
        parent_name: "",
        remainder_date: "",
        remainder_time: "",
        type_customer: "",
        remark: "",
        email: "",
        source: "",
        borrowAmount: ""
    })
    const [openCardStates, setOpenCardStates] = useState({});
    const [shareAComponent, setShareAComponent] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const token = decryptToken("accessToken") || ""
    const [showLeadsdetailsModal, setShwoLeadsDetailsModal] = useState(false);
    const [followupDescription, setFollowupDescription] = useState("");
    const [followupStatus, setFollowupStatus] = useState("Pending");

    const openLeadsDetails = () => {
        setShwoLeadsDetailsModal(true);
    };

    const closeLeadsDetails = () => {
        setSelectedLeadId(null);
    };

    const handleOpenRatingModal = (lead) => {
        setSelectedLead(lead); // store full lead (includes lead.rating)
        setShareAComponent(true); // open modal
    };

    const url = API_BASE_URL
    const BASE_URL = `${url}`

    // const isOpen = openCardId === lead.id;

    const openRatingPopup = (lead) => {
        setSelectedLeadForRating(lead);
        setShowRatingPopup(true);
    };

    // const toggleDetails = (leadId) => {
    //     setOpenCardId(prevId => (prevId === leadId ? null : leadId));
    // };

    const toggleDetails = (leadId) => {
        setOpenCardStates(prev => ({
            ...prev,
            [leadId]: !prev[leadId]
        }));
    };

    const numberToWords = (num) => {
        const a = [
            '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
            'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen',
            'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
        ];
        const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (n) => {
            n = Math.floor(n); // Ensure it's a whole number

            if (n === 0) return 'Zero';
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
            if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + convert(n % 100) : '');
            if (n < 100000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '');
            if (n < 10000000) return convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '');
            return convert(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + convert(n % 10000000) : '');
        };

        if (isNaN(num) || num === null) return 'Invalid Number';

        return convert(num);
    };




    const closeRatingPopup = () => {
        setShowRatingPopup(false);
        setSelectedLeadForRating(null);
    };

    const openEnquiryModalEdit = () => {
        setShowEnquiryModalEdit(true);
    };

    const closeEnquiryModalEdit = () => {
        setShowEnquiryModalEdit(false);
        // fetchLeadsData();
    };

    const closeReminderModal = () => {
        setShowReminderModal(false);
        setSelectedDate(null);
        setSelectedTime(null);
        setCustomTime(null);
        setCustomDate(null);
    };

    const handleDateSelection = (date) => {
        setSelectedDate(date);
        setSelectedTime(null); // Reset time on new date
        setCustomTime(null);
    };

    const getRelativeTime = (timestamp) => {
        if (!timestamp) return "Not Available";

        const pastTime = moment(timestamp).tz("Asia/Kolkata"); // parse ISO and convert to IST
        const now = moment().tz("Asia/Kolkata");

        if (!pastTime.isValid()) return "Invalid date";

        const duration = moment.duration(now.diff(pastTime));

        if (duration.asSeconds() < 60) {
            const seconds = Math.floor(duration.asSeconds());
            return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
        } else if (duration.asMinutes() < 60) {
            const minutes = Math.floor(duration.asMinutes());
            return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
        } else if (duration.asHours() < 24) {
            const hours = Math.floor(duration.asHours());
            return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
        } else if (duration.asDays() < 7) {
            const days = Math.floor(duration.asDays());
            return `${days} day${days !== 1 ? 's' : ''} ago`;
        } else if (duration.asWeeks() < 4) {
            const weeks = Math.floor(duration.asWeeks());
            return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
        } else if (duration.asMonths() < 12) {
            const months = Math.floor(duration.asMonths());
            return `${months} month${months !== 1 ? 's' : ''} ago`;
        } else {
            const years = Math.floor(duration.asYears());
            return `${years} year${years !== 1 ? 's' : ''} ago`;
        }
    };



    const openQuotationModal = (lead) => {
        setShowQuotationModal(true);
        setLeadsData(lead);
    };

    const closeQuotationModal = () => {
        setShowQuotationModal(false);
    };

    const openPreviewModal = () => {
        setShowPreviewModal(true);
    };
    const closePreviewModal = () => {
        setShowPreviewModal(false);
    };

    const [selectedLeadForReminder, setSelectedLeadForReminder] = useState(null);
    const [selectedRemainder, setSelectedRemainder] = useState(null)

    const openReminderModal = (lead) => {
        setSelectedLeadForReminder(lead);

        // PREFILL DATE
        if (lead.remainder_date) {
            setCustomDate(lead.remainder_date);

            // Detect if stored date is today / tomorrow
            const today = new Date().toISOString().split("T")[0];
            const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];

            if (lead.remainder_date === today) {
                setSelectedDate("today");
            } else if (lead.remainder_date === tomorrow) {
                setSelectedDate("tomorrow");
            } else {
                setSelectedDate("pick-date");
            }
        } else {
            setSelectedDate(null);
        }

        // PREFILL TIME
        if (lead.remainder_time) {
            setCustomTime(lead.remainder_time);

            // Check predefined time options
            if (lead.remainder_time === "10:00") setSelectedTime("10am");
            else if (lead.remainder_time === "14:00") setSelectedTime("2pm");
            else setSelectedTime("custom");
        } else {
            setSelectedTime(null);
        }

        // PREFILL DESCRIPTION + STATUS
        setFollowupDescription(lead.followup_description || "");
        setFollowupStatus(lead.followup_status || "Pending");

        setShowReminderModal(true);
    };




    const openNoteModal = (lead) => {
        setShowNoteModal(true);
        setLeadsData(lead);
    };

    const closeNoteModal = () => {
        setShowNoteModal(false);
    };


    const handleClickContact = () => {
        setClickedContact(true);
    };


    // Handle selection of individual leads
    // const handleSelectLead = (id) => {
    //     setSelectedLeads(prevSelected => {
    //         const updatedSelections = prevSelected[currentPage] ? [...prevSelected[currentPage]] : [];

    //         if (updatedSelections.includes(id)) {
    //             // Remove if already selected
    //             return {
    //                 ...prevSelected,
    //                 [currentPage]: updatedSelections.filter(leadId => leadId !== id),
    //             };
    //         } else {
    //             // Add if not selected
    //             return {
    //                 ...prevSelected,
    //                 [currentPage]: [...updatedSelections, id],
    //             };
    //         }
    //     });
    // };

    const handleSelectLead = (id) => {
        setSelectedLeads(prevSelected => {
            const updatedSelections = prevSelected[currentPage] ? [...prevSelected[currentPage]] : [];

            if (updatedSelections.includes(id)) {
                // ✅ Remove color from newly assigned leads when deselected
                setNewlyAssignedLeads((prev) => prev.filter((leadId) => leadId !== id));
                setAlreadyAssignedLeads((prev) => prev.filter((leadId) => leadId !== id));

                return {
                    ...prevSelected,
                    [currentPage]: updatedSelections.filter(leadId => leadId !== id),
                };
            } else {
                return {
                    ...prevSelected,
                    [currentPage]: [...updatedSelections, id],
                };
            }
        });
    };


    const toggleSelection = (id) => {
        setSelectedLeads((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter(leadId => leadId !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };


    // Handle Select All functionality
    useEffect(() => {
        if (selectedLeads.length === leads.length && leads.length > 0) {
            setSelectedLeads(leads.map(lead => lead.id)); // Select all
        }
    }, [leads]);

    // const toggleStarred = (id) => {
    //     setStarredLeads((prev) => ({ ...prev, [id]: !prev[id] }));
    // };

    const toggleStarred = async (lead) => {
        try {
            const response = await fetch(`${url}/leads/toggle-starred/${lead.id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ star: !lead.star }), // Toggle the starred value
            });

            if (response.ok) {
                const updatedLead = await response.json();
                // Update state to reflect the change
                setLeads((prevLeads) =>
                    prevLeads.map((l) => (l.id === lead.id ? { ...l, star: updatedLead.star } : l))
                );
            }
        } catch (error) {
            console.error("Error updating starred status:", error);
        }
    };






    // Calculate total amount
    const calculateTotal = () => {
        let basePrice = pricePerUnit;

        let discountAmount = 0;
        if (showDiscount && discount > 0) {
            discountAmount = (basePrice * discount) / 100;
        }

        let gstAmount = 0;
        if (showGST && gst > 0) {
            gstAmount = (basePrice * gst) / 100;
        }

        const total = (basePrice - discountAmount) + gstAmount;

        return total.toFixed(2);
    };

    const handleContactClick = async (lead, contactType) => {
        try {
            const response = await fetch(`${url}/leads/update-mark/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            });

            if (response.ok) {
                fetchLeads();
            }
            // Redirect based on contact type
            if (contactType === "phone") {
                window.location.href = `tel:${lead.mobile}`;
            } else if (contactType === "whatsapp") {
                const whatsappNumber = lead.mobile.replace(/\D/g, ""); // Ensure only numbers
                window.open(`https://wa.me/${whatsappNumber}`, "_blank");
            } else if (contactType === "email") {
                window.location.href = `mailto:${lead.age}`;
            }

        } catch (error) {
            console.error("Error updating mark:", error);
        }
    };

    const fetchLeads = async () => {
        try {
            const response = await fetch(`${url}/leads/getall`, {

                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });
            const data = await response.json();
            setLeads(data);
        } catch (error) {
            console.error("Error fetching leads:", error);
        }
    };

    const convertToIST = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            // day: "2-digit",
            // month: "short",
            // year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const convertToISTUtc = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const convertToISTMain = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            // day: "2-digit",
            // month: "short",
            // year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            // second: "2-digit",
            hour12: true
        });
    };



    const handleNotesSubmit = async () => {
        try {
            const response = await fetch(`${url}/notec`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    remark: notes,
                    property_id: leadsData.id,
                    property: leadsData.business_name,
                    phone: isLoggedIn.full_name,
                    user_id: isLoggedIn.main_id
                })
            })
            if (response.ok) {
                const res = await response.json();
                fetchNotes(leadsData.id);
                setNotes("")
                // fetchLeads();
                toast.success("Note added successfully");
                closeNoteModal();
            }
        } catch (error) {
            console.error(error);
            toast.error(error);
        }
    }

    const fetchNotes = async (id) => {
        try {
            const response = await fetch(`${url}/notec/all/${(id)}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },

            });
            const res = await response.json();
            setNotesData(res.reverse());
        } catch (error) {
            console.error(error);
        }
    }

    const handleStatusChange = async (newStatus, lead) => {
        try {
            const response = await fetch(`${url}/leads/change/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ extra: newStatus }), // send only the updated field
            });

            const data = await response.json(); // ✅ Parse the response JSON

            if (response.ok) {
                if (data.warning) {
                    toast.warning(data.warning);  // ⚠️ show warning toast
                } else {
                    toast.success(data.message || "Status updated successfully");
                }

                setLeads(prev =>
                    prev.map(item =>
                        item.id === lead.id ? { ...item, extra: newStatus } : item
                    )
                );
            } else {
                toast.error(data.message || "Failed to update status");
            }
        } catch (err) {
            console.error("Error updating status:", err);
            toast.error("An error occurred while updating status");
        }
    };



    const handleSendQuotation = async () => {
        const payload = {
            user_id: leadsData.id,
            user_name: leadsData.name === "" ? leadsData.business_name : leadsData.name,
            service_name: productName,
            quantity,
            price_per_unit: pricePerUnit,
            gst,
            discount,
            notes: addNote,
            staff_name: "Admin",
            total_amount: calculateTotal(),
        };

        try {
            const response = await fetch(`${url}/quotation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (response.ok) {
                handleWhatsAppSend(payload)
                toast.success("Quotation sent and saved successfully!");
                // Optionally close modal or reset fields

            } else {
                toast.error(data.message || "Failed to send quotation.");
            }
        } catch (err) {
            console.error("Error sending quotation:", err);
            toast.error("Something went wrong while sending the quotation.");
        }
    };

    const handleWhatsAppSend = (lead) => {
        const totalFormatted = `₹${calculateTotal().toLocaleString("en-IN")}`;

        const message = `
      Dear ${lead.user_name},
      Greetings from ${isLoggedIn.name}!
      
      Here's the information you requested:
      
      • Building/Project Name: ${lead.service_name}
      • Carpet Area: ${lead.quantity} sq.ft
      • Total Price: ${totalFormatted}
      • Note: ${lead.notes}
      
      
      Thank you!
        `.trim();

        const phone = leadsData.mobile.replace(/\D/g, "");
        const fullPhone = phone.startsWith("91") ? phone : `91${phone}`;
        const encodedMessage = encodeURIComponent(message);

        const url = `https://api.whatsapp.com/send?phone=${fullPhone}&text=${encodedMessage}`;

        window.open(url, "_blank");
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // For mobile number validation
        if (name === "mobile") {
            // Allow only digits
            const numericValue = value.replace(/\D/g, "");

            // Check if it starts with 6-9 and is up to 10 digits
            if (numericValue === "" || /^[6-9]\d{0,9}$/.test(numericValue)) {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: numericValue,
                }));
            }

            return; // Exit to avoid setting invalid mobile number
        }

        // For other fields
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${url}/leads/change/${formData.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formData)
            })
            const res = await response.json();
            if (response.ok) {
                fetchLeads();
                toast.success("Enquiry updated successfully!", {
                    position: "top-center",
                    autoClose: 3000,
                });
                closeEnquiryModalEdit();
            } else {
                toast.error(`${res.message}`, {
                    position: "top-center",
                    autoClose: 3000, // Close toast after 3 seconds
                });
            }
        } catch (error) {
            toast.error(`${error}`, {
                position: "top-center",
                autoClose: 10000, // Close toast after 3 seconds
            });
        }
    }


    useEffect(() => {
    }, [newlyAssignedLeads]);

    const formatIndianCurrency = (amount) => {
        return Number(amount).toLocaleString('en-IN');
    };

    const handleDeleteLead = async (id, name, business) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: `You want to delete ${name === "" ? business : name}  permanently!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await fetch(`${BASE_URL}/leads/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                fetchLeads();
                Swal.fire("Deleted!", `${name === "" ? business : name} has been deleted.`, "success");
            } catch (error) {
                console.error("Error deleting property:", error);
                Swal.fire("Error!", "Failed to delete the property. Try again later.", "error");
            }
        }
    }

    const updateLead = (id, updatedFields) => {
        setLeads(prevLeads =>
            prevLeads.map(lead =>
                lead.id === id ? { ...lead, ...updatedFields } : lead
            )
        );
    };

    const [itemsOptions, setItemsOptions] = useState([]);

    const fetchServiceData = async () => {
        try {
            const res = await fetch(`${url}/offerings/all/${isLoggedIn.main_id}`);
            const data = await res.json();
            setItemsOptions(data);
        } catch (error) {
            console.error("Error fetching offerings:", error);
        }
    };


    useEffect(() => {
        fetchNotes();
        fetchServiceData();
    }, [])


    return (
        <>
            {
                leads.map((lead) => {
                    const isCardOpen = openCardStates.hasOwnProperty(lead.id)
                        ? openCardStates[lead.id]
                        : lead.mark === "Read"; // default to open if mark is Read

                    return <div className={`card-rating `}>
                        <div className={`lsuv-card ${lead.mark === "New" ? "lsuv-active-card" : ""}
    ${alreadyAssignedLeads.includes(lead.id) ? "already-assigned" : ""} 
    ${newlyAssignedLeads.includes(lead.id) ? "" : ""}`}
                            key={lead.id}
                        >
                            <div className="lsuv-card__header">
                                <div className="">
                                    {lead.remainder_date && lead.remainder_time && (
                                        <>
                                            <p className="text-sm tracking-wider">
                                                <strong>Reminder:</strong> {lead.followup_description || "No description"}
                                            </p>
                                            <p className="text-xs tracking-wide text-gray-500">
                                                {lead.remainder_date}, {lead.remainder_time}
                                            </p>
                                        </>
                                    )}
                                </div>
                                <div className="lsuv-card__row lsuv-card__row--top">
                                    <div className="lsuv-card__left">
                                        <div className="lsuv-card__checkbox">
                                            <input type="checkbox"
                                                checked={selectedLeads[currentPage]?.includes(lead.id) || false}
                                                onChange={() => handleSelectLead(lead.id)}
                                            />
                                        </div>
                                        <div className="lsuv-card__status">
                                            <span className={`lsuv-status ${lead.mark === "Read" ? "lsuv-status--read" : "lsuv-status--unread"}`}>
                                                {lead.mark === "New" ? lead.mark : (lead.rate_message === "" || lead.rate_message === null) ? lead.mark : lead.rate_message}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="lsuv-card__right">
                                        <span className="lsuv-card__timestamp">{convertToISTUtc(lead.createdAt)}</span>
                                    </div>
                                </div>

                                <div className="lsuv-card__row lsuv-card__row--bottom">
                                    <div className="lsuv-card__left">
                                        <div className="lsuv-card__star-icon" onClick={() => toggleStarred(lead)}>
                                            <i
                                                className={lead.star ? "fa-solid fa-star starred" : "fa-regular fa-star unstarred"}
                                            ></i>
                                        </div>
                                        <div className="lsuv-card__title">
                                            <p>{(lead.name === "" || lead.name === null) ? lead.business_name : lead.name}</p>
                                            {/* <p>Company name</p> */}
                                        </div>
                                    </div>
                                    <div className="lsuv-card__right">
                                        <div className="lsuv-card__contact-icons">
                                            {
                                                lead.mobile ? <a
                                                    href="#"
                                                    className={`ls-card-icon ls-call ${clickedContact ? "clicked" : ""}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleContactClick(lead, "phone");
                                                    }}
                                                >
                                                    <i className="fas fa-phone"></i>
                                                </a> : null
                                            }
                                            {
                                                lead.email
                                                    ? (
                                                        <a
                                                            href="#"
                                                            className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleContactClick(lead, "email");
                                                            }}
                                                        >
                                                            <i className="fas fa-envelope"></i>
                                                        </a>
                                                    )
                                                    : lead.email
                                                        ? (
                                                            <a
                                                                href="#"
                                                                className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleContactClick(lead, "email");
                                                                }}
                                                            >
                                                                <i className="fas fa-envelope"></i>
                                                            </a>
                                                        )
                                                        : null
                                            }
                                            {
                                                lead.mobile ? <a
                                                    href='#'
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleContactClick(lead, "whatsapp");
                                                    }}
                                                >
                                                    <i className="fab fa-whatsapp"></i>
                                                </a> : null
                                            }
                                            <a
                                                href="#"
                                                className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setSelectedLeadId(lead);
                                                    openLeadsDetails();
                                                }}
                                            >
                                                <i className="fas fa-eye"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="lsuv-middle-footer">
                                <div className="lsuv-card__middle">
                                    <div className="lsuv-card__address">
                                        <p>{lead.address} {lead.city} {lead.pincode}</p>
                                    </div>
                                    {lead.serviceType ? (
                                        <div className="lsuv-card__service">
                                            <p><strong>Service name:</strong> {lead.serviceType}</p>
                                        </div>
                                    ) : null}
                                    <div className="lsuv-card__assigned">
                                        {lead.AssignLeads && lead.AssignLeads.length > 0 ? (
                                            <p>
                                                <strong>Assigned to:</strong>{" "}
                                                {lead.AssignLeads.map((assign, index) => (
                                                    <span key={assign.id}>
                                                        {assign.staff_name.replace(/\(ID:.*?\)/, "").trim()}
                                                        {index < lead.AssignLeads.length - 1 ? ", " : ""}
                                                    </span>
                                                ))}
                                            </p>
                                        ) : null}
                                    </div>


                                    {
                                        (lead.remark) ?
                                            <div className="lsuv-card__message">
                                                <p><strong>Message:</strong>{lead.remark}</p>
                                            </div>
                                            : null
                                    }
                                </div>
                                <div className="lsuv-card__footer-section">
                                    <div className="lsuv-card__action-group">
                                        <div className="lsuv-card__action">
                                            <button
                                                className="flex items-center gap-2 bg-gray-100 border border-gray-300 text-sm tracking-wide px-3 py-1.5 rounded-md hover:bg-gray-200 transition relative"
                                                onClick={() =>
                                                    navigate("/crm-message", {
                                                        state: {
                                                            mobile: lead.mobile || null,
                                                            email: lead.email || null,
                                                            name: lead.name || "",
                                                            leadId: lead.id,
                                                            type_customer: lead.type_customer || "",
                                                            address: lead.address || "",
                                                            city: lead.city || "",
                                                            pincode: lead.pincode || "",
                                                            source: lead?.source || lead?.enquiry_source,
                                                            AssignLeads: lead?.AssignLeads || [],
                                                            extra: lead.extra || "",
                                                            lead: lead
                                                        },
                                                    })
                                                }
                                            >
                                                <Mail size={16} />
                                                Messages

                                                <span className="shake flex items-center justify-center w-5 h-5 rounded-full bg-gray-600 text-white text-xs font-semibold">
                                                    {lead.otherCount}
                                                </span>
                                            </button>


                                        </div>
                                        <div className="lsuv-card__action">
                                            <button className="flex items-center gap-1.5 bg-gray-100 border border-gray-300 text-sm tracking-wide px-3 py-1.5 rounded-md hover:bg-gray-200 transition"
                                                onClick={() => {
                                                    openNoteModal(lead)
                                                    fetchNotes(lead.id)
                                                }}
                                            >
                                                <StickyNote size={16} /> Add notes
                                            </button>
                                        </div>
                                        <div className="lsuv-card__action">
                                            <button
                                                className="flex items-center gap-1.5 bg-gray-100 border border-gray-300 text-sm tracking-wide px-3 py-1.5 rounded-md hover:bg-gray-200 transition"
                                                onClick={() => openReminderModal(lead)}
                                            >
                                                <Bell size={16} />
                                                {lead.remainder_date ? "Edit Reminder" : "Add Reminder"}
                                            </button>

                                        </div>
                                        {/* <div className="lsuv-card__action">
                                            <button className="lsuv-card__btn"
                                                onClick={() => openRatingPopup(lead)}>
                                                <i className="fa fa-star"></i> Ask rating
                                            </button>
                                        </div> */}
                                        <div className="relative w-max">
                                            <select
                                                name="extra"
                                                value={lead.extra || ""}
                                                id="status"
                                                className="appearance-none tracking-wide bg-gray-100 border border-gray-300 text-sm px-3 py-1.5 pr-7 rounded-md cursor-pointer focus:border-gray-400 focus:outline-none transition"
                                                onChange={(e) => handleStatusChange(e.target.value, lead)}
                                            >
                                                <option value="">Select</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Converted">Converted</option>
                                                <option value="Not Interested">Not Interested</option>
                                                <option value="In Progress">In Progress</option>
                                            </select>
                                            <ChevronDown className="w-4 h-4 text-gray-500 absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none" />
                                        </div>
                                        <div className="lsuv-card__action">
                                            <button className="flex items-center gap-1.5 bg-gray-100 border border-gray-300 text-sm tracking-wide px-3 py-1.5 rounded-md hover:bg-gray-200 transition"
                                                onClick={() => {
                                                    setFormData({
                                                        id: lead.id,
                                                        name: lead.name,
                                                        mobile: lead.mobile,
                                                        business_name: lead.business_name,
                                                        address: lead.address,
                                                        city: lead.city,
                                                        pincode: lead.pincode,
                                                        parent_name: lead.parent_name,
                                                        remainder_date: lead.remainder_date,
                                                        remainder_time: lead.remainder_time,
                                                        type_customer: lead.type_customer,
                                                        remark: lead.remark,
                                                        email: lead.email,
                                                        source: lead.source,
                                                        borrowAmount: lead.borrowAmount
                                                    })
                                                    setShowEnquiryModalEdit(true)
                                                }}>
                                                <EditIcon size={16} /> Edit Leads
                                            </button>
                                        </div>
                                    </div>

                                    {/* <div className="lsuv-card__quote-button">
                                        <button className="lsuv-card__btn-primary"
                                            onClick={() => {
                                                openQuotationModal(lead)
                                            }}
                                        >
                                            <i className="fa fa-paper-plane"></i> Send Quotation
                                        </button>
                                    </div> */}
                                    {
                                        lead.type_customer ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Customer Type:</strong> {lead.type_customer}</p>
                                            </div>
                                            : null
                                    }

                                    {
                                        lead.enquiry_source ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Enquiry Source:</strong> {lead.enquiry_source}</p>
                                            </div>
                                            : null
                                    }
                                    {
                                        lead.source ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Source:</strong> {lead.source || lead.enquiry_source}</p>
                                            </div>
                                            : null
                                    }
                                    {lead.borrowAmount ? (
                                        <div className="lsuv-card__source-info">
                                            <p>
                                                <strong>Borrow Amount:</strong> {numberToWords(Number(lead.borrowAmount.replace(/,/g, '')))}
                                                (₹ {formatIndianCurrency(Number(lead.borrowAmount.replace(/,/g, '')))})
                                            </p>
                                        </div>
                                    ) : null}
                                    {lead.monthlySalary ? (
                                        <div className="lsuv-card__source-info">
                                            <p>
                                                <strong>Monthly Salary:</strong> {numberToWords(Number(lead.monthlySalary.replace(/,/g, '')))}
                                                (₹ {formatIndianCurrency(Number(lead.monthlySalary.replace(/,/g, '')))})
                                            </p>
                                        </div>
                                    ) : null}

                                </div>
                            </div>

                            <div className="lsuv-card__meta-footer">
                                {/* <div
                                    className="lsuv-card__toggle-details"
                                    onClick={() => toggleDetails(lead.id)}
                                >
                                    {isCardOpen ? 'Hide Details' : 'Show Details'}
                                </div> */}

                                <div className="connected-delete-crm">
                                    {
                                        lead.connected_time ?
                                            <div className="lsuv-card__connection-info">
                                                <p>Connected {getRelativeTime(lead.connected_time)}</p>
                                            </div>
                                            : null
                                    }
                                    <div className="crm-delete-icon" onClick={() => handleDeleteLead(lead.id, lead.name, lead.business_name)}>
                                        <i class="fa-solid fa-trash" title="Delete Lead"></i>
                                    </div>
                                    {
                                        (lead.rating && lead.rate_message) ?
                                            <div className="crm-border-card"></div> : null
                                    }
                                    {
                                        (lead.rating && lead.rate_message) ? <div className="re-rating-btn-crm" onClick={() => handleOpenRatingModal(lead)}>
                                            <p>{lead.rating} <i class="fa-solid fa-star"></i></p>
                                        </div> : null
                                    }
                                </div>

                            </div>
                        </div>

                        {
                            (
                                !lead.rating ||
                                !lead.rate_message
                            ) && lead.mark === "Read" ? <RatingComponent inquiryId={lead.id} mark={lead.mark} leadsDataRatingMain={leadsDataMain}
                                updateLead={updateLead}
                            /> : null

                        }

                        {shareAComponent && selectedLead && selectedLead.id === lead.id &&
                            (lead.mark === "Read") && (
                                <RatingEditComponent
                                    inquiryId={selectedLead.id}
                                    mark={selectedLead.mark}
                                    initialRating={selectedLead.rating}
                                    initialRateMessage={selectedLead.rate_message}
                                    leadsDataMain={leadsDataMain}
                                    updateLead={updateLead}
                                />
                            )}


                    </div>
                })}

            {showRatingPopup && selectedLeadForRating && (
                <div className="ls-modal">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Send Rating Request</h2>
                            <button className="quotation-close" onClick={closeRatingPopup}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <p>Choose how you'd like to request a rating from <strong>{selectedLeadForRating.name}</strong>:</p>

                        <div className="rating-options">
                            <button
                                className="whatsapp-btn"
                                onClick={() => {
                                    const message = `Hi ${selectedLeadForRating.name},
                We would greatly appreciate your valuable feedback.
                Please take a moment to leave us a review on Google:
                👉 https://g.page/r/CQccMqyEJYQ7EBM/review
                
                Thank you for your support!`;
                                    const phone = selectedLeadForRating.mobile.replace(/\D/g, "");
                                    const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;
                                    window.open(url, "_blank");
                                    closeRatingPopup();
                                }}
                            >
                                <i className="fab fa-whatsapp"></i> WhatsApp
                            </button>

                            <button
                                className="sms-btn"
                                onClick={() => {
                                    const smsBody = `Hi ${selectedLeadForRating.name},
                We would greatly appreciate your valuable feedback.
                Please take a moment to leave us a review on Google:
                👉 https://g.page/r/CQccMqyEJYQ7EBM/review
                
                Thank you for your support!`;
                                    window.open(`sms:${selectedLeadForRating.mobile}?body=${encodeURIComponent(smsBody)}`);
                                    closeRatingPopup();
                                }}
                            >
                                <i class="fa-solid fa-envelope"></i>Message
                            </button>

                            {
                                selectedLeadForRating.age ? <button
                                    className="email-btn"
                                    onClick={() => {
                                        const subject = "We’d love your feedback!";
                                        const body = `Hi ${selectedLeadForRating.name},
                \n\nWe would greatly appreciate your valuable feedback.
                Please take a moment to leave us a review on Google:
                👉 https://g.page/r/CQccMqyEJYQ7EBM/review
                
                Thank you for your support!`;
                                        window.location.href = `mailto:${selectedLeadForRating.age}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                                        closeRatingPopup();
                                    }}
                                >
                                    <i className="fas fa-envelope"></i> Email
                                </button> : null
                            }
                        </div>
                    </div>
                </div>
            )}


            {showQuotationModal && (
                <div className="quotation-modal">
                    <div className="quotation-container">
                        <div className="quotation-header">
                            <h2>Generate and Send Quotation</h2>
                            <button className="quotation-close" onClick={() => setShowQuotationModal(false)}><i className="fa-solid fa-xmark"></i></button>
                        </div>
                        <div className="quotation-content">
                            <div className="quotation-input-grp">
                                <input
                                    type="text"
                                    value={productName}
                                    onChange={(e) => setProductName(e.target.value)}
                                    placeholder="Enter Project/Building Name"
                                />
                            </div>
                            <div className="quotation-input-flex">
                                <div className="quotation-input-grp quotation-price-per-unit">
                                    <label htmlFor="quotation-price-per-unit">Property Price</label>
                                    <input
                                        type="number"
                                        name="quotation-price-per-unit"
                                        value={pricePerUnit}
                                        placeholder="₹1000"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setPricePerUnit(value === "" ? "" : Number(value));
                                        }}
                                    // onChange={(e) => setPricePerUnit(Number(e.target.value))}
                                    />
                                    {
                                        pricePerUnit > 0 &&
                                        <small style={{ fontSize: "12px", color: "#3399ff", fontWeight: "600", marginTop: "3px" }}>
                                            {convertToINRWords(pricePerUnit)}
                                        </small>
                                    }
                                </div>
                                <div className="quotation-input-grp quotation-quantity">
                                    <label htmlFor="quotation-quantity">Carpet Area</label>
                                    <input
                                        type="number"
                                        name="quotation-quantity"
                                        value={quantity}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setQuantity(value === "" ? "" : Number(value));
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="quotation-input-flex">
                                <div className="quotation-input-grp">
                                    <div className="quotation-toggle">
                                        <label>Add GST (%)</label>
                                        <span className="quotation-toggle-icon" onClick={() => setShowGST(!showGST)}>
                                            <i className={`fas ${showGST ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </span>
                                    </div>
                                    {showGST &&
                                        <input
                                            type="number"
                                            placeholder="GST %"
                                            value={gst}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setGst(value === "" ? "" : Number(value));
                                            }}

                                        />
                                    }
                                </div>
                                <div className="quotation-input-grp">
                                    <div className="quotation-toggle">
                                        <label>Add Discount (%)</label>
                                        <span className="quotation-toggle-icon" onClick={() => setShowDiscount(!showDiscount)}>
                                            <i className={`fas ${showDiscount ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </span>
                                    </div>
                                    {showDiscount &&
                                        <input
                                            type="number"
                                            placeholder="Discount %"
                                            value={discount}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setDiscount(value === "" ? "" : Number(value));
                                            }}

                                        />
                                    }
                                </div>
                            </div>
                            <div className="quotation-input-grp">
                                <input
                                    type="text"
                                    value={addNote}
                                    onChange={(e) => setAddNote(e.target.value)}
                                    placeholder="Add notes"
                                />
                            </div>

                            <div className="quotation-footer">
                                <p className="quotation-total-amt">
                                    <div>Total Amount:</div>
                                    <div>₹{calculateTotal()}</div>
                                </p>
                                <div className="quotation-preview">
                                    <button onClick={() => openPreviewModal()}><i className="fa-solid fa-eye"></i>Preview quote</button>
                                </div>
                                <div onClick={handleSendQuotation} className="quotation-whatsapp">
                                    <button><i className="fa-brands fa-whatsapp"></i>WhatsApp</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {showPreviewModal && (
                <div className="preview-modal">
                    <div className="preview-container">
                        <div className="quotation-header">
                            <h2>Quotation preview</h2>
                            <button className="quotation-close" onClick={closePreviewModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <div className="chat-message">
                            <p>
                                Dear <strong>{leadsData.name === "" ? leadsData.business_name : leadsData.name}</strong>,<br />
                                Greetings from <strong>{isLoggedIn.name}</strong>!<br />
                                Here's the information you requested:<br />
                                <strong>Product Name:</strong>{productName}<br />
                                <strong>Quantity:</strong> {quantity}<br />
                                <strong>Note:</strong>{addNote}<br />
                                <strong>Total Price:</strong> ₹{calculateTotal()}
                            </p>
                        </div>
                        <div className="quotation-footer">
                            <div className="quotation-preview edit-quotation">
                                <button onClick={closePreviewModal}><i className="fa-solid fa-pencil"></i>Edit quote</button>
                            </div>
                            <div className="quotation-whatsapp" onClick={handleSendQuotation} >
                                <button><i className="fa-brands fa-whatsapp"></i> WhatsApp</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showReminderModal && (
                <div className="ls-modal">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Set reminder</h2>
                            <button className="quotation-close" onClick={closeReminderModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <h2>Select Date</h2>
                        <div className="ls-modal-options">
                            <label className={`ls-radio-option ${selectedDate === "today" ? "selected" : ""}`} onClick={() => handleDateSelection("today")}>
                                Today
                            </label>
                            <label className={`ls-radio-option ${selectedDate === "tomorrow" ? "selected" : ""}`} onClick={() => handleDateSelection("tomorrow")}>
                                Tomorrow
                            </label>
                            <label className={`ls-radio-option ${selectedDate === "pick-date" ? "selected" : ""}`} onClick={() => handleDateSelection("pick-date")}>
                                Pick a Date
                            </label>
                        </div>

                        {/* Show Time Options for Today */}
                        {selectedDate === "today" && (
                            <div className="ls-time-options">
                                <h3>Select Time</h3>
                                <div className="ls-modal-options">
                                    <label className={`ls-radio-option ${selectedTime === "30min" ? "selected" : ""}`} onClick={() => setSelectedTime("30min")}>
                                        In 30 minutes
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "2hours" ? "selected" : ""}`} onClick={() => setSelectedTime("2hours")}>
                                        In 2 hours
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "custom" ? "selected" : ""}`} onClick={() => setSelectedTime("custom")}>
                                        Pick a Time
                                    </label>
                                </div>
                            </div>
                        )}

                        {/* Show Time Options for Tomorrow */}
                        {selectedDate === "tomorrow" && (
                            <div className="ls-time-options">
                                <h3>Select Time</h3>
                                <div className="ls-modal-options">
                                    <label className={`ls-radio-option ${selectedTime === "10am" ? "selected" : ""}`} onClick={() => setSelectedTime("10am")}>
                                        10:00 AM
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "2pm" ? "selected" : ""}`} onClick={() => setSelectedTime("2pm")}>
                                        2:00 PM
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "custom" ? "selected" : ""}`} onClick={() => setSelectedTime("custom")}>
                                        Pick a Time
                                    </label>
                                </div>
                            </div>
                        )}

                        {/* Custom Time Picker */}
                        {selectedTime === "custom" && (
                            <div className="ls-time-picker">
                                <input
                                    type="time"
                                    value={customTime || ""}
                                    onChange={(e) => setCustomTime(e.target.value)}
                                />
                            </div>
                        )}

                        {/* Pick Date and Time together */}
                        {selectedDate === "pick-date" && (
                            <>
                                <div className="lsuv-pick-date-time">
                                    <div className="ls-date-picker">
                                        <label>Date</label>
                                        <input
                                            type="date"
                                            value={customDate || ""}
                                            onChange={(e) => setCustomDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="ls-time-picker">
                                        <label>Time</label>
                                        <input
                                            type="time"
                                            value={customTime || ""}
                                            onChange={(e) => setCustomTime(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="ls-form-group mt-2">
                            <label>Description</label>
                            <textarea
                                className="ls-textarea"
                                value={followupDescription}
                                onChange={(e) => setFollowupDescription(e.target.value)}
                            ></textarea>
                        </div>

                        <div className="ls-modal-action">
                            <button className="ls-modal-cancel" onClick={closeReminderModal}>Cancel</button>
                            <button
                                className="ls-apply-btn"
                                onClick={async () => {
                                    if (!selectedLeadForReminder) return;

                                    const finalDate =
                                        selectedDate === "pick-date"
                                            ? customDate
                                            : selectedDate === "today"
                                                ? new Date().toISOString().split("T")[0]
                                                : selectedDate === "tomorrow"
                                                    ? new Date(Date.now() + 86400000).toISOString().split("T")[0]
                                                    : customDate;

                                    let finalTime =
                                        selectedTime === "custom"
                                            ? customTime
                                            : selectedTime === "30min"
                                                ? new Date(Date.now() + 1800000).toTimeString().slice(0, 5)
                                                : selectedTime === "2hours"
                                                    ? new Date(Date.now() + 7200000).toTimeString().slice(0, 5)
                                                    : selectedTime === "10am"
                                                        ? "10:00"
                                                        : selectedTime === "2pm"
                                                            ? "14:00"
                                                            : customTime;

                                    const payload = {
                                        remainder_date: finalDate,
                                        remainder_time: finalTime,
                                        followup_time: finalTime,
                                        followup_description: followupDescription,
                                        followup_status: followupStatus
                                    };

                                    try {
                                        await axios.put(
                                            `${url}/leads/change/${selectedLeadForReminder.id}`,
                                            payload,
                                            {
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    Authorization: `Bearer ${token}`,   // REQUIRED
                                                }
                                            }
                                        );

                                        toast.success("Reminder updated successfully!");

                                        // Schedule local / native notification
                                        await ensureCrmNotificationPermission();
                                        scheduleCrmReminderAfterSave(selectedLeadForReminder, payload);

                                        // Update UI
                                        updateLead(selectedLeadForReminder.id, payload);

                                        closeReminderModal();
                                    } catch (e) {
                                        toast.error("Failed to set reminder");
                                    }
                                }}
                            >
                                {selectedLeadForReminder?.remainder_date ? "Update" : "Apply"}
                            </button>

                        </div>
                    </div>
                </div>
            )}

            {showNoteModal && (
                <div className="ls-modal ls-modal-note">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Set note</h2>
                            <button className="quotation-close" onClick={closeNoteModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        {/* <form > */}
                        <div className="ls-modal-options">
                            <textarea
                                placeholder="Write notes..."
                                name="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            ></textarea>
                        </div>
                        <div className="ls-modal-action">
                            <button className="ls-modal-cancel" onClick={closeNoteModal}>Cancel</button>
                            <button type="submit" className="ls-apply-btn" onClick={handleNotesSubmit}>Add notes</button>
                        </div>
                        {/* </form> */}
                        {
                            notesData.length > 0 ? <div className="recorded-notes">
                                <div className="quotation-header">
                                    <h2>Recorded notes</h2>
                                </div>
                                <div className="recorded-note-lists">
                                    {notesData.map((ele, idx) => {
                                        const formattedDate = new Date(ele.createdAt).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true
                                        });
                                        return (
                                            <div className="recorded-note-items">
                                                <p className="recorded-note-date-time">
                                                    {formattedDate} (
                                                    {ele.phone === isLoggedIn.full_name ? "You" : ele.user_name}
                                                    )
                                                </p>

                                                <p className="recorder-note-content">
                                                    {ele.remark}
                                                </p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}

            {showEnquiryModalEdit && (
                <div className="ls-enquiry-modal">
                    <div className="ls-enquiry-modal-content">
                        <div className="quotation-header">
                            <h2><i className="fa-solid fa-envelope"></i> New Enquiry</h2>
                            <button className="quotation-close" onClick={closeEnquiryModalEdit}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="ls-form-group">
                                <label>Customer/Business Owner Name</label>
                                <input type="text" name="name" placeholder="Enter full name" value={formData.name} onChange={handleInputChange} />
                            </div>
                            <div className="ls-form-group">
                                <label>Mobile Number*</label>
                                <input
                                    type="text"
                                    name="mobile"
                                    placeholder="Enter mobile number"
                                    value={formData.mobile}
                                    onChange={handleInputChange}
                                    maxLength={10}
                                    required
                                />

                                {formData.mobile.length > 0 && formData.mobile.length < 10 && (
                                    <p style={{ color: "red", fontSize: "12px" }}>
                                        Mobile number must be 10 digits and start with 6, 7, 8, or 9
                                    </p>
                                )}

                            </div>

                            <div className="ls-form-group">
                                <label>Email</label>
                                <input type="email" name="email" placeholder="Enter email address" value={formData.email} onChange={handleInputChange} />
                            </div>
                            <div className="ls-form-group">
                                <label>Business Name</label>
                                <input type="text" name="business_name" placeholder="Enter business name" value={formData.business_name} onChange={handleInputChange} />
                            </div>

                            <div className="ls-form-group">
                                <label>Address</label>
                                <input type="text" name="address" placeholder="Enter address" value={formData.address} onChange={handleInputChange} />
                            </div>

                            <div className="ls-form-row">
                                <div className="ls-form-group">
                                    <label>City</label>
                                    <input type="text" name="city" placeholder="Enter city" value={formData.city} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Pincode</label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        placeholder="Enter pincode"
                                        value={formData.pincode}
                                        onChange={handleInputChange}

                                    />

                                </div>

                            </div>

                            {/* <div className="ls-form-group">
                                <label>Required Service</label>
                                <select className="ls-categoryservice" name="parent_name" id="service" value={formData.parent_name} onChange={handleInputChange}>
                                    <option value="">What service do you need?</option>
                                    {
                                        services.map((service, index) => (
                                            <option key={index} value={service}>{service}</option>
                                        ))}
                                </select>
                            </div> */}

                            <div className="ls-form-group">
                                <label>Add Note</label>
                                <textarea name="remark" placeholder="Additional notes..." value={formData.remark} onChange={handleInputChange}></textarea>
                            </div>

                            {/* <div className="ls-form-row">
                                <div className="ls-form-group">
                                    <label>Reminder Date</label>
                                    <input type="date" name="remainder_date" value={formData.remainder_date} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Reminder Time</label>
                                    <input type="time" name="remainder_time" value={formData.remainder_time} onChange={handleInputChange} />
                                </div>
                            </div> */}

                            <div className="ls-form-group">
                                <label>Enquiry Source</label>
                                <input type="text" name="source" placeholder="Where did you hear about us?" value={formData.source} onChange={handleInputChange} />
                            </div>

                            <div className="ls-form-group">
                                <label>Type of Customer</label>
                                <div className="ls-radio-group">
                                    <label className={`ls-radio-option ${formData.type_customer === "Business" ? "selected" : ""}`} onClick={handleInputChange}>
                                        <input type="radio" name="type_customer" value="Business" checked={formData.type_customer === "new"} readOnly /> Business
                                    </label>
                                    <label className={`ls-radio-option ${formData.type_customer === "Salaried" ? "selected" : ""}`} onClick={handleInputChange}>
                                        <input type="radio" name="type_customer" value="Salaried" checked={formData.type_customer === "Salaried"} readOnly /> Salaried
                                    </label>
                                </div>
                            </div>
                            <div className="ls-modal-action">
                                <button className="ls-modal-cancel" onClick={closeEnquiryModalEdit}>Cancel</button>
                                <button className="ls-apply-btn">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            )
            }
            {selectedLeadId && (
                <div className="ls-enquiry-modal">
                    <div className="ls-enquiry-modal-content">
                        <div className="quotation-header">
                            <h2>Leads Details</h2>
                            <button className="quotation-close" onClick={closeLeadsDetails}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <div className="leads-detail-modal-body-crm">
                            <div className="lead-details-list-crm">
                                <div><strong>Customer Name:</strong> {selectedLeadId.name || "N/A"}</div>
                                <div><strong>Mobile Number:</strong> {selectedLeadId.mobile || "N/A"}</div>
                                <div><strong>Email:</strong> {selectedLeadId.email || "N/A"}</div>
                                <div><strong>Business Name:</strong> {selectedLeadId.business_name || "N/A"}</div>
                                <div><strong>Address:</strong> {selectedLeadId.address || "N/A"}</div>
                                <div><strong>City:</strong> {selectedLeadId.city || "N/A"}</div>
                                <div><strong>Pincode:</strong> {selectedLeadId.pincode || "N/A"}</div>
                                <div><strong>Note:</strong> {selectedLeadId.remark || "N/A"}</div>
                                <div><strong>Source:</strong> {selectedLeadId.source || "N/A"}</div>
                                <div><strong>Type of Customer:</strong> {selectedLeadId.type_customer || "N/A"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default CRMUpdatedVersionCards;
